import { render } from "./PAddVideo.vue?vue&type=template&id=78fbc489"
import script from "./PAddVideo.vue?vue&type=script&lang=js"
export * from "./PAddVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__